module.exports = __webpack_public_path__ + "static/media/recovery-img-2.1299669b.png";